<template>
	<div>
		<vs-row>
			<vx-card title="Afgeronde bestellingen">
				<template slot="actions">
					<vx-tooltip class="flex" text="Hoe en wat?">
						<font-awesome-icon icon="question-circle" @click="wiki"></font-awesome-icon>
					</vx-tooltip>
				</template>

				<div class="vx-col pt-2 pb-2">
					<div class="flex flex-wrap">
						<div class="mr-2">
							<vx-input-group>
								<template slot="prepend">
									<div class="prepend-text bg-primary">
										<span>Bestelnummer</span>
									</div>
								</template>
								<vs-input placeholder="Zoeken" v-model="search" />
							</vx-input-group>
							<div class="text-xs text-right" v-if="orderHistory.ordersCount > 0">
								{{ orderHistory.ordersCount }} bestellingen gevonden
							</div>
						</div>
					</div>
				</div>

				<vs-table :data="orderHistory.orders">
					<vs-tr>
						<vs-th></vs-th>
						<vs-th>Bestelnummer</vs-th>
						<vs-th>Verzonden op</vs-th>
						<vs-th>Voor & achternaam</vs-th>
						<vs-th colspan="2">Verzonden</vs-th>
					</vs-tr>

					<vs-tr :key="order.id" v-for="order in this.orderHistory.orders">
						<td>
							<div class="flex float-left">
								<img v-if="order.order.type === 1" src="@/assets/images/orders/types/bol.png" alt="content-img" style="max-height: 40px">
								<img v-if="order.order.type === 2" src="@/assets/images/orders/types/lightspeed.png" alt="content-img" style="max-height: 40px">
							</div>
							<div class="flex float-left pl-5">
								<order-status :order="order" />
							</div>
						</td>
						<td>
							{{ order.order.type_id_visible }}
						</td>
						<td>
							{{ order.order.updated_at }}
						</td>
						<td>
							{{ order.shipping.full_name }}
						</td>
						<td>
							<div v-if="order.items[0].transport_track_and_trace">
								{{ order.items[0].transport_code }} {{ order.items[0].transport_track_and_trace }}
							</div>
							<div v-else-if="!order.items.transport_track_and_trace">
								{{ order.items[0].transport_code }} Geen track & trace
							</div>
						</td>
						<td>
							<font-awesome-icon :icon="['fas', 'info-circle']" size="2x" @click="openInfoScreen(order)" />
						</td>
					</vs-tr>
				</vs-table>

				<div class="vx-row justify-center mt-5">
					<div class="vx-col">
						<vs-pagination :total="maxPages" v-model="page"></vs-pagination>
					</div>
				</div>
			</vx-card>
		</vs-row>

		<vs-popup :fullscreen="true" :title="`Bestelling overzicht #${popup.visible? popup.order.order.type_id_visible : ''}`" :active.sync="popup.visible">
			<order-details-popup :order="popup.order" v-if="popup.visible" :dymo-printer="dymoPrinter" />
		</vs-popup>
	</div>
</template>

<script>
import dymoPrinter from '@/services/dymo/dymoPrinter';
import OrderDetailsPopup from '@/views/orderDetails/orderDetailsPopup';
import OrderStatus from '@/views/orders/components/status';

export default {
	name: 'orderHistory',
	components: {
		OrderStatus,
		OrderDetailsPopup,
	},
	data() {
		return {
			orderHistory: [],
			orderSort: 'dateNewOld',
			search: '',
			page: 1,
			page_size: 10,
			maxPages: 0,
			popup: {
				visible: false,
				order: null,
			},
			dymoPrinter: new dymoPrinter(),
		}
	},
	mounted() {
		this.$vs.loading();
		this.dymoPrinter.init();
		this.getOrderHistory();
	},
	watch: {
		'orderSort'(newSort) {
			this.sortHistoryChange(newSort);
		},
		'search'(newSearch) {
			this.changeSearch(newSearch);
		},
		'page'(newPage) {
			this.changePage(newPage);
		}
	},
	methods: {
		getOrderHistory() {
			this.$store.dispatch('orderHistory/getOrderHistory',
				{
					sort_by: this.orderSort,
					search: this.search,
					page_size: this.page_size,
					page: this.page
				}).then(res => {
				this.orderHistory = this.$store.state.orderHistory;
				this.maxPages = Math.ceil(this.orderHistory.orderCount / this.page_size);
				this.$vs.loading.close();
			})
		},
		openInfoScreen(order) {
			this.popup.order = order;
			this.popup.visible = true;
		},
		sortHistoryChange(orderSort) {
			this.orderSort = orderSort;

			this.getOrderHistory();
		},
		changeSearch(search) {
			this.search = search;

			this.getOrderHistory();
		},
		changePageSize(pageSize) {
			this.page_size = pageSize;

			this.getOrderHistory();
		},
		changePage(page) {
			this.page = page;

			this.getOrderHistory();
		},
		wiki() {
			window.open(this.$store.state.wiki.wiki.ordersCompleted)
		}
	}
}
</script>
